module.exports = __webpack_public_path__ + "img/path-6.03cc85aa.svg";